import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { Product } from "../../../domain/entities/product/Product";
import { TrackingEventName } from "./tracking";
import { useTrackWhishlistItem } from "./useTrackWhishlistItem";

interface TrackWhishlistItemAddedFunctionArgs {
  readonly product: Product;
}

interface TrackWhishlistItemAddedFunction {
  (args: TrackWhishlistItemAddedFunctionArgs): void;
}

interface UseTrackWhishlistItemAddedFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackWhishlistItemAddedFunction {
  (agrs: UseTrackWhishlistItemAddedFunctionArgs): TrackWhishlistItemAddedFunction;
}

const useTrackWhishlistItemAdded: UseTrackWhishlistItemAddedFunction = ({ country, segment, tradename, userId }) => {
  const trackWhishlistItem = useTrackWhishlistItem({
    event: TrackingEventName.WISHLIST_ITEM_ADDED,
    country,
    segment,
    tradename,
    userId,
  });

  const trackWhishlistItemAdded: TrackWhishlistItemAddedFunction = useCallback(
    ({ product }) => {
      trackWhishlistItem({
        product,
      });
    },
    [trackWhishlistItem],
  );

  return trackWhishlistItemAdded;
};

export { useTrackWhishlistItemAdded };
